module.exports = __webpack_public_path__ + "img/next-step.0accbde4.png";